import * as React from "react";
import { useMemo } from "react";
import SelectableMessageTableMessagesContext from "./SelectableMessageTableMessagesContext";
const defaultIsEntitySelectable = () => true;
const SelectableMessageTableMessagesProvider = ({
  children = null,
  displayBulkSelectCol = false,
  isEntitySelectable = defaultIsEntitySelectable,
  messages
}) => {
  const contextValue = useMemo(() => {
    if (!displayBulkSelectCol) {
      return { selectableMessageTableMessages: [] };
    }
    return {
      selectableMessageTableMessages: messages.filter((message) => {
        var _a;
        return !!((_a = message.message) == null ? void 0 : _a._id) && isEntitySelectable(message);
      }).map(
        ({ index, message }) => ({
          id: message._id,
          index,
          timestamp: message.timestamp
        })
      )
    };
  }, [displayBulkSelectCol, isEntitySelectable, messages]);
  return /* @__PURE__ */ React.createElement(SelectableMessageTableMessagesContext.Provider, { value: contextValue }, children);
};
export default SelectableMessageTableMessagesProvider;
